import Select from './Select';

export default Select;



// WEBPACK FOOTER //
// ./app/javascript/common/components/Select/index.js